import React from 'react';
import './ContentStyle.css';

function TermsPage() {

  return (
    <div className="Aa000">
      <div className='container'>
        <div className='header'>
          <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-logo.png' /></div>
        </div>
        <div className='form-content'>
          <div className='form-content-top'>
            <div className='logo'><img alt='GameLand' src='%PUBLIC_URL%/../../gameland-banner.png' /></div>
          </div>
          <div id='terms' className='form-content-middle'>
            <ul style={{ listStyleType: 'none'}}>
              1. Introduction<br></br>
              <li>Welcome to Gameland! These Terms of Use govern your access to and use of the Gameland gaming service ("Service"), a web-based HTML5 gaming platform available on all devices. By using the Service, you agree to comply with these terms. If you do not agree, please do not use Gameland.</li>
            </ul>

            <br></br><br></br><br></br>

            <ul style={{ listStyleType: 'none' }}>
              2. Service Description<br></br>
              <li>Gameland offers a collection of HTML5 games accessible via a web-based platform. The Service is available to users in Kenya and requires an active subscription.</li>
            </ul>

            <br></br><br></br><br></br>

            <ul style={{ listStyleType: 'none' }}>
              3. Subscription and Pricing<br></br>
              <li>The Service is available for <b>15 KSH per day</b>, with an initial<b>1-day free trial</b>.</li>
              <li>Subscription is automatically renewed daily unless canceled by the user.</li>
              <li>Charges will be deducted from your mobile balance or billed via your mobile carrier.</li>
              <li>To unsubscribe, send <b>STOP</b> to <b>27806</b>contact support.</li>
            </ul>

            <br></br><br></br><br></br>

            <ul style={{ listStyleType: 'none' }}>
              4. User Responsibilities<br></br>
              <li>You must be at least 18 years old or have parental/guardian consent to use the Service.</li>
              <li>You agree to use the Service for personal, non-commercial purposes.</li>
              <li>Any misuse, hacking, or unauthorized access to the Service is strictly prohibited.</li>
            </ul>

            <br></br><br></br><br></br>

            <ul style={{ listStyleType: 'none' }}>
              5. Support and Contact<br></br>
              <li>For any issues, inquiries, or support requests, please contact us at <b><a href='mailto:support@ke-gameland.com'>support@ke-gameland.com</a></b></li>
            </ul>

            <br></br><br></br><br></br>

            <ul style={{ listStyleType: 'none' }}>
              6. Changes to the Terms<br></br>
              <li>Gameland reserves the right to update or modify these Terms of Use at any time. Continued use of the Service after changes constitute acceptance of the revised terms.</li>
            </ul>

            <br></br><br></br><br></br>

            <ul style={{ listStyleType: 'none' }}>
              7. Termination<br></br>
              <li>Gameland may suspend or terminate access to users who violate these Terms of Use without prior notice.
                By subscribing to Gameland, you acknowledge and agree to these Terms of Use.</li>
            </ul>

          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;